import React, {
  createContext,
  PropsWithChildren,
  useContext,
  useMemo,
  useState,
} from 'react';
import {PermGroupsEnum, UserPermissionEnum} from '../../schema-types/globalTypes';

export interface FilterFormValue {
  everything: boolean;
  businessUnitIds: string[];
  permissionOverride: boolean;
  permission?: UserPermissionEnum;
  group?: PermGroupsEnum;
}

interface PermissionsAuditContextState extends FilterFormValue {
  search?: string;
}

interface PermissionsAuditContextType {
  state: PermissionsAuditContextState;
  setState: React.Dispatch<React.SetStateAction<PermissionsAuditContextState>>;
  initialState: PermissionsAuditContextState;
}

export const PermissionsAuditContext = createContext<PermissionsAuditContextType>(
  {} as PermissionsAuditContextType
);

export const usePermissionsAuditContext = () => useContext(PermissionsAuditContext);

export const PermissionsAuditProvider: React.FC<PropsWithChildren> = ({children}) => {
  const initialState: PermissionsAuditContextState = {
    everything: false,
    businessUnitIds: [],
    permissionOverride: false,
    permission: undefined,
    group: undefined,
  };
  const [state, setState] = useState<PermissionsAuditContextState>(initialState);

  const value = useMemo(() => {
    return {state, setState, initialState};
  }, [state, setState, initialState]);

  return (
    <PermissionsAuditContext.Provider value={value}>
      {children}
    </PermissionsAuditContext.Provider>
  );
};
